import VueGtag from 'vue-gtag'
import router from '@/router'

const isProd = process.env.NODE_ENV === 'production'

export default {
  install(Vue) {
    const options = {
      enabled: isProd,
      config: {
        id: process.env.VUE_APP_GA_CODE,
      },
      pageTrackerEnabled: false,
    }

    Vue.use(VueGtag, options, router)

    Vue.prototype.$pageView = pageView

    function pageView() {
      Vue.$gtag.pageview({
        page_path: this.$route.path,
        page_title: this.$metaInfo && this.$metaInfo.title,
      })
    }

    Vue.directive('gtagEvent', {
      bind(el, binding) {
        el.addEventListener('click', trackEvent, { passive: true })
        el.addEventListener('touchstart', trackEvent, { passive: true })
        el.dataset.trackingObject = JSON.stringify(makeEvent(binding))
      },

      update(el, binding) {
        el.dataset.trackingObject = JSON.stringify(makeEvent(binding))
      },
      unbind(el) {
        el.removeEventListener('click', trackEvent, { passive: true })
        el.removeEventListener('touchstart', trackEvent, { passive: true })
      },
    })

    function trackEvent(e) {
      const eventData = this.dataset.trackingObject
      if (eventData) {
        Vue.$gtag.event('click', JSON.parse(eventData))
      }
    }

    function makeEvent(binding) {
      const supportedEvents = [
        'device-detect-manufacturer',
        'device-detect-model',
        'detection-result-close'
      ]

      const event = supportedEvents.find(x => binding.modifiers[x])
      if (event) {
        return {
          event_category: event,
          event_label: (binding.value || '').trim(),
        }
      }
    }
  },
}
